export default window.jQuery || window.$;
